import React from 'react'
import ReactDOM from 'react-dom';

import { connect } from 'react-redux'
import { get, keys } from 'lodash'
import Dimensions from 'react-dimensions'
import { scaleLinear } from "d3-scale"
import './index.css'
import { Origin } from 'redux-tooltip';
import { Link } from 'react-router-dom'
import { saveSvgAsPng } from 'save-svg-as-png'
import { getCsvFile } from '../../utils/csvdownload'

const Opolyline = Origin.wrapBy('polyline');

const mapStateToProps = (state, props) => ({
  countries: state.countries,
  indicators: state.indicators,
  tfaMeta: state.tfaMeta,
})

export const BLUE_TOPICS = [
  'inf_availability',
  'inv_community',
  'adv_rulings',
  'appeal_proc',
  'fees_charges',
  'form_docs',
  'form_auto',
  'form_proc',
  'int_cooperation',
  'ext_cooperation',
  'gov_impartiality',
]


const Ray = ({className, content, centerX, centerY, angle, radius, rayBase, notFocused}) => {

  const x2 = centerX + Math.cos(angle) * radius
  const y2 = centerY + Math.sin(angle) * radius

  const xb2 = centerX + Math.cos(angle+Math.PI/2) * rayBase
  const yb2 = centerY + Math.sin(angle+Math.PI/2) * rayBase

  const xb1 = centerX + Math.cos(angle-Math.PI/2) * rayBase
  const yb1 = centerY + Math.sin(angle-Math.PI/2) * rayBase

  const points = `${xb1},${yb1} ${xb2},${yb2} ${xb2},${yb2} ${x2},${y2} ${x2},${y2} ${xb1},${yb1}`
  const opacity = notFocused ? 0.3 : 1

  return (
    <Opolyline points={points} className={className} content={content} style={{fillOpacity:opacity, strokeOpacity:opacity}}/>
  )
}



class StarChartBlock_ extends React.PureComponent {


  render() {

    const { 
      indicators,
      tfaMeta,
      latestDataByIndicator,
      tfaArticles,
      countryCode,
      margin=10, //for labels, etc..
      blueTopics=BLUE_TOPICS,
      inlineColor=null,
      focusedOptions,
      containerWidth } = this.props

    if(!indicators || !tfaArticles){ return null}

    const allIndicators = blueTopics//.concat(redTopics)
    const width = containerWidth - ( margin * 2 )
    const maxRadius = width / 2
    const centerX = containerWidth/2
    const centerY = containerWidth/2

    const RAYBASE = maxRadius / 40


    const leftSector = Math.PI / ( blueTopics.length + 1 )

    let scales = allIndicators.reduce((a,v,i)=>{
      if(!indicators[v]){
        console.error("missing indicator:", v)
        return a
      }
      const range = indicators[v].rankDirection === "1" ? [maxRadius, 0] : [0, maxRadius]
      // let domain = indicators[v].domain
      let domain = [0, 2]
      a[v] = scaleLinear().range(range).domain(domain)
      return a
    }, {})

    const tfaArticlesKeys = keys(tfaArticles)

    let tfaScales = tfaArticlesKeys.reduce((a,v,i)=>{
      const range =  [0, maxRadius]
      let domain = [0, tfaMeta[v]["max"]]
      a[v] = scaleLinear().range(range).domain(domain)
      return a
    }, {})


    const redTopics = keys(tfaArticles)
    const rightSector = Math.PI / ( redTopics.length + 1 )
    return (
        <g>
          { inlineColor && (
          <g>
            <rect style={{fill:inlineColor, stroke:'none', fillOpacity:0.1}} x={margin+2} y={margin+2} width={width-4} height={width-4}></rect>
          </g>
          )}

          { blueTopics.map((topic, i) => {
            if(!latestDataByIndicator[topic]){
              // console.log("missing indicator", topic, countryCode)
              return null
            }
            const countryData = latestDataByIndicator[topic][countryCode]
            const value = get(countryData, 'v')
            if(!value){ return null}

            const angle = ( i + 1 ) * leftSector + (Math.PI / 2)
            const radius = scales[topic](value)
            // const x2 = centerX + Math.cos(angle) * radius
            // const y2 = centerY + Math.sin(angle) * radius

            let notFocused = false;
            if(focusedOptions){
              notFocused = get(focusedOptions, 'ind', []).indexOf(topic) === -1
            }

            return (
              // <Oline key={topic} x1={center} y1={center} x2={x2} y2={y2} className="StarChart__blue"
              // content={`${indicators[topic].shortTitle || indicators[topic].globalId }: ${value} `}/>
              <Ray key={topic}
                centerX={centerX} centerY={centerY} angle={angle} radius={radius} rayBase={RAYBASE}
                content={`${indicators[topic].shortTitle || indicators[topic].globalId }: ${value} `}
                className="StarChart__blue" notFocused={notFocused}/>
            )
          }) }
          { tfaArticlesKeys.map((topic, i) => {
            const countryData = tfaArticles[topic][countryCode]
            const value = get(countryData, 'v')
            if(!value){ return null}

            const angle = (Math.PI / 2) - ( i + 1 ) * rightSector

            const radius = tfaScales[topic](value)

            let notFocused = false;
            if(focusedOptions){
              notFocused = get(focusedOptions, 'tfa', []).indexOf(topic) === -1
            }

            return (
              // <Oline key={topic} x1={center} y1={center} x2={x2} y2={y2} className="StarChart__red"
              // content={`${topic}: ${value} `}/>
              <Ray key={topic}
                centerX={centerX} centerY={centerY} angle={angle} radius={radius} rayBase={RAYBASE}
                content={`Article ${topic}: ${Math.round(value/tfaMeta[topic]["max"]*1000)/10}`}
                className="StarChart__red" notFocused={notFocused}/>
            )
          }) }

          <g>
            <circle cx={centerX} cy={centerY} r={RAYBASE}></circle>
          </g>

        </g>


    )
  }
}

export const StarChartBlock = connect(mapStateToProps)(StarChartBlock_)

class StarChart extends React.PureComponent {

  downloadPng = (e) => {
    const { countryCode } = this.props
    var node = ReactDOM.findDOMNode(this)

    const dk = node.querySelector(".download-links")
    dk.classList.add("hide")
    const donly = node.querySelector(".download-only")
    if(donly){
      donly.classList.remove("hide")
    }
    saveSvgAsPng(node, `${countryCode}-star.png`, { backgroundColor: '#fff'})
    dk.classList.remove("hide")
    if (donly) {
      donly.classList.add("hide")
    }
  }

  downloadCsv =  (e) => {
    const { countryCode, blueTopics=BLUE_TOPICS, tfaArticles } = this.props
    getCsvFile(`${countryCode}-country-facilitation.csv`, [countryCode], blueTopics, keys(tfaArticles))
  }

  render() {

    const { 
      latestDataByIndicator,
      tfaArticles,
      countryCode,
      countries,
      borderColor='#0D66A5',
      margin=40, //for labels, etc..
      blueTopics=BLUE_TOPICS,
      redTopics=[],
      selectedTopics=[],
      showCountryLabel=true,
      showDownloads=false,
      height=null,
      inlineColor,
      focusedOptions,
      containerWidth } = this.props

    const passProps = { latestDataByIndicator, tfaArticles, countryCode,
      margin, blueTopics, redTopics, selectedTopics, containerWidth:800, inlineColor, focusedOptions }

    const chartHeight = height === null ? containerWidth : height
    const ratificationDateOrPhrase = get(tfaArticles, `[1][${countryCode}]["date"]`) || ''

    return (
      <svg className="StarChart__svg" viewBox={`0 0 800 800`}
        style={{border:borderColor ? `solid ${borderColor} 1px` : undefined}}
        height={chartHeight} width={containerWidth}>
        <g transform={`translate(${margin}, ${margin})`} className={`${showCountryLabel ? '' : 'hide download-only'}`}>
          <text y={margin/2} className="SunBurstChart__country_label">
          <Link to={`//countries/${countryCode}`}>
            {countries[countryCode]}
          </Link>
          </text>
        </g>

        { showDownloads && (
          <g className="download-links" transform={`translate(${margin}, ${margin})`}>
          <text y={margin/2} className="SunBurstChart__download_title">DOWNLOAD</text>
          <text y={margin/2 + 40}>
            <tspan className="SunBurstChart__download_label pointer" onClick={this.downloadCsv}>CSV</tspan>
            <tspan>&nbsp;&nbsp;&nbsp;</tspan>
            <tspan className="SunBurstChart__download_label pointer" onClick={this.downloadPng}>VIZ</tspan>
          </text>
          </g>
        )}

        <StarChartBlock {...passProps} />

        { true && <g transform={`translate(${800/2}, ${800-margin})`}>
          <text y={margin/2} className="StarChart__ratification_label">
          {ratificationDateOrPhrase.match(/^\d\d\.\d\d\.\d{4}$/) 
              ? `Has ratified the TFA on ${ratificationDateOrPhrase}` 
              : ratificationDateOrPhrase.match(/^Has/)
              ? ratificationDateOrPhrase
              : `Has not ratified the TFA as of 18.07.2017`
            }
          </text>
        </g>}
      </svg>
    )
  }

}

export default connect(mapStateToProps)(Dimensions()(StarChart))



// WEBPACK FOOTER //
// ./src/components/StarChart/index.js